import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

// 獲取 baseURL，基於環境變量自動設置

// 創建 Axios 實例
const apiClient = axios.create({
  // baseURL: "http://localhost:7246/api", // 後端 API 的根路徑
  baseURL:
   "https://azurewinghotel-api.christylove.com.tw/api", // 後端 API 的根路徑

  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 支援 Cookies（如果需要）
});

// 添加請求攔截器，用於攜帶 Authorization 標頭
apiClient.interceptors.request.use(
  (config) => {
    // 檢查是否是 /reset 相關的請求
    if (config.url && config.url.includes("/reset")) {
      // 對 /reset 請求，不附加 Authorization 標頭
      return config;
    }

    const token = Cookies.get("token"); // 與你的組件保持一致
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // 添加 Authorization 標頭
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加響應攔截器，用於統一處理401錯誤
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 處理401未授權錯誤（token過期或無效）
    if (error.response?.status === 401) {
      console.log("Token已過期，清除登入狀態並跳轉到登入頁面");

      // 清除token
      Cookies.remove("token");

      // 顯示提示訊息
      Swal.fire({
        icon: "warning",
        title: "登入已過期",
        text: "您的登入已過期，請重新登入！",
        confirmButtonText: "確定",
      }).then(() => {
        // 跳轉到登入頁面
        window.location.href = "/login";
      });
    }

    return Promise.reject(error);
  }
);

// 統一的 API 調用方法
export default {
  // GET 請求
  get(endpoint, params = {}) {
    return apiClient.get(endpoint, { params });
  },

  // POST 請求
  post(endpoint, data) {
    return apiClient.post(endpoint, data);
  },

  // PUT 請求
  put(endpoint, data) {
    return apiClient.put(endpoint, data);
  },

  // DELETE 請求
  delete(endpoint) {
    return apiClient.delete(endpoint);
  },
};
